import { render } from "./VideoHome.vue?vue&type=template&id=6938f599&scoped=true"
import script from "./VideoHome.vue?vue&type=script&lang=js"
export * from "./VideoHome.vue?vue&type=script&lang=js"

import "./VideoHome.vue?vue&type=style&index=0&id=6938f599&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6938f599"]])

export default __exports__